/* components/SiteHeader.ts
Global Site Header

Example
<site-header>
    Site header content here
</site-header>
*/

import { Component, Ref, Prop } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import { cart } from "@/theme/Cart";
import { CartMain } from '../Cart/CartMain';

@Component
export class SiteHeader extends ThemeComponent {

    @Prop ({ default: false}) offset!: boolean;
    @Ref() row!: HTMLDivElement;
    @Ref({required: false}) cartTrigger!: HTMLDivElement;
    @Ref() cartCount!: HTMLSpanElement;
    private heroBanner: HTMLDivElement | null;
    private siteHeader: HTMLDivElement | null;

    constructor() {
        super();
        this.heroBanner = document.querySelector('.hero');
        this.siteHeader = document.querySelector('.site-header');
    }

    init() {
        this.$subscribe(cart.onChange, () => {
            if (cart.itemCount <= 0) {
                this.cartCount.classList.remove('active');
            } else {
                this.cartCount.classList.add('active');
            }
            this.cartCount.textContent = cart.itemCount.toString();
        });

        cart.itemsWithDisplayQuantities.map((row) => {

            row.item;
            row.displayQuantity;

        });

        this.handleBannerPadding();
        this.cartEvent();
    }

    /**
     * Handle Body Padding.
     */
    private handleBannerPadding() {
        const height = this.row.offsetHeight;
        if (this.heroBanner) {
            this.heroBanner.style.paddingTop = `${height}px`;
        }
    }


    /**
     * Cart Close click event.
     * @returns
     */
    cartEvent() {
        if (this.cartTrigger) {
            this.$listen(this.cartTrigger, 'click', (event) => {
                event.preventDefault();
                document.dispatchEvent(new Event('cartOpen'));
            });
        }
    }

    cartUpdated() {
        if (cart.items.length <= 0) {
            this.cartCount.classList.add('hidden');
            return;
        }
        this.cartCount.classList.remove('hidden');
        this.cartCount.innerHTML = String(cart.items.length);
    }
}
